import Reflux from "reflux";
import { CloudForwarderForwarderInputProfiles } from "@graylog/enterprise-api";
import fetch from "logic/rest/FetchProvider";
import UserNotification from "util/UserNotification";
import inputsUrl from "forwarder/forwarders/inputsUrl";
export const ForwarderInputsActions = Reflux.createActions({
  list: { asyncResult: true },
  listAll: { asyncResult: true },
  create: { asyncResult: true },
  update: { asyncResult: true },
  delete: { asyncResult: true }
});
const ForwarderInputsStore = Reflux.createStore({
  listenables: [ForwarderInputsActions],
  forwarderInputs: {},
  pagination: {
    total: 0,
    count: 0,
    page: 1,
    perPage: 10,
    query: ""
  },
  getInitialState() {
    return this.getState();
  },
  getState() {
    return {
      forwarderInputs: this.forwarderInputs,
      pagination: this.pagination
    };
  },
  propagateUpdate() {
    this.trigger(this.getState());
  },
  list({ inputProfileId, query = "", page = 1, pageSize = 10 }) {
    const promise = fetch(
      "GET",
      inputsUrl({
        segments: ["profiles", inputProfileId, "inputs"],
        query: {
          query,
          page,
          per_page: pageSize
        }
      })
    );
    promise.then(
      (response) => {
        this.forwarderInputs = { ...this.forwarderInputs, [inputProfileId]: response.forwarder_inputs };
        this.pagination = {
          total: response.total,
          count: response.count,
          page: response.page,
          perPage: response.per_page,
          query
        };
        this.propagateUpdate();
        return response;
      },
      (error) => {
        UserNotification.error(`Retrieving Forwarder Input failed with status: ${error.message},
        Could not retrieve Forwarder Inputs`);
      }
    );
    ForwarderInputsActions.list.promise(promise);
  },
  listAll({ inputProfileId, query = "", page = 1, pageSize = 0 }) {
    const promise = fetch(
      "GET",
      inputsUrl({
        segments: ["profiles", inputProfileId, "inputs"],
        query: {
          query,
          page,
          per_page: pageSize
        }
      })
    );
    promise.then(
      (response) => {
        this.forwarderInputs = { ...this.forwarderInputs, [inputProfileId]: response.forwarder_inputs };
        this.pagination = {
          total: response.total,
          count: response.count,
          page: response.page,
          perPage: response.per_page,
          query
        };
        this.propagateUpdate();
        return response;
      },
      (error) => {
        UserNotification.error(`Retrieving Forwarder Input failed with status: ${error.message},
        Could not retrieve Forwarder Inputs`);
      }
    );
    ForwarderInputsActions.listAll.promise(promise);
  },
  create(inputProfileId, input) {
    const promise = CloudForwarderForwarderInputProfiles.createByinputProfileIdAndJSONBody(
      encodeURIComponent(inputProfileId),
      input
    );
    promise.then(
      (response) => {
        UserNotification.success("Forwarder Input created successfully");
        return response;
      },
      (error) => {
        UserNotification.error(`Forwarder Input create failed with status: ${error.message},
        Could not create Forwarder Input`);
      }
    );
    ForwarderInputsActions.create.promise(promise);
  },
  update(inputProfileId, inputId, input) {
    const promise = CloudForwarderForwarderInputProfiles.updateByinputProfileIdAndforwarderInputIdAndJSONBody(
      encodeURIComponent(inputProfileId),
      encodeURIComponent(inputId),
      input
    );
    promise.then(
      (response) => {
        UserNotification.success("Forwarder Input updated successfully");
        return response;
      },
      (error) => {
        UserNotification.error(`Forwarder Input update failed with status: ${error.message},
        Could not update Forwarder Input`);
      }
    );
    ForwarderInputsActions.update.promise(promise);
  },
  delete(inputProfileId, input) {
    const promise = fetch("DELETE", inputsUrl({ segments: ["profiles", inputProfileId, "inputs", input.id] }));
    promise.then(
      (response) => {
        UserNotification.success("Forwarder Input deleted successfully");
        return response;
      },
      (error) => {
        UserNotification.error(`Forwarder Input delete failed with status: ${error.message},
        Could not delete Forwarder Input`);
      }
    );
    ForwarderInputsActions.delete.promise(promise);
  }
});
export default ForwarderInputsStore;
